import { Link } from "react-router-dom";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import { Button } from "@/components/uiDir/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/uiDir/card";

const Terms = () => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main className="container mx-auto px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-4xl mx-auto">
          <div className="mb-10">
            <h1 className="text-4xl font-heading font-bold mb-2">Terms of Service</h1>
            <p className="text-muted-foreground">
              Please review the guidelines for using PortfolioHub.
            </p>
          </div>

          <div className="space-y-6">
            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Account Responsibilities</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Keep your account information accurate and maintain respectful conduct.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Content Guidelines</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                Only upload work you have the right to share and give credit where required.
              </CardContent>
            </Card>

            <Card className="glass-card">
              <CardHeader>
                <CardTitle>Service Updates</CardTitle>
              </CardHeader>
              <CardContent className="text-sm text-muted-foreground">
                We may update features or policies to improve the platform experience.
              </CardContent>
            </Card>
          </div>

          <div className="mt-8 flex flex-wrap gap-3">
            <Link to="/privacy">
              <Button variant="outline">View Privacy Policy</Button>
            </Link>
            <Link to="/">
              <Button variant="ghost">Back to Home</Button>
            </Link>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default Terms;
